import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function digitsOnly(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value === null || value === undefined || value === "") {
            return null; // let required handle empty
        }

        return /^\d+$/.test(String(value)) ? null : { digitsOnly: true };
    };
}
